module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"background_color":"#e2e2e2","display":"standalone","icon":"src/images/favicon.jpg","name":"Charity Grace Bible Church","short_name":"Charity Grace","start_url":"/","theme_color":"#286483","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"04f74fe7d5e9d1290ef7f11e8a66baed"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
